module.exports = __webpack_public_path__ + "img/nm_home_header_illustration0.7fa9db83.png";